import { useState, useEffect } from "react";

export type ScreenSize = "base" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";

// Tailwind breakpoints in px
const breakpoints: Record<ScreenSize, number> = {
  base: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
  "3xl": 1920,
};

const useScreenSize = (size: ScreenSize = "sm") => {
  const [matches, setMatches] = useState<boolean>(() =>
    typeof window !== "undefined" ? window.innerWidth <= breakpoints[size] : false
  );

  useEffect(() => {
    const handleResize = () => {
      setMatches(window.innerWidth <= breakpoints[size]);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // initial check

    return () => window.removeEventListener("resize", handleResize);
  }, [size]);

  return matches;
};

export default useScreenSize;
